import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  kitId: string;
  spaceId: string | number;
  version: number;
};

const [useUpdateRecommendedVersion, updateRecommendedVersion] = createAsyncAction(
  "kits/updateRecommendedVersion",
  async ({ kitId, spaceId, version }: Args) => {
    return await API.call<string>({
      endpoint: `kits/${spaceId}/${kitId}`,
      method: "PUT",
      data: {
        use_version: version,
      },
      entity: API.Entity.kit,
    });
  }
);
export default useUpdateRecommendedVersion;
export { updateRecommendedVersion };
